import { Box, ButtonBase, Chip, Stack, Typography } from '@mui/material';
import { CheckCircleIcon } from '@phosphor-icons/react';

import { PRIVACY_TIERS, type PrivacyTier } from '@/lib/onboarding/privacy-tiers';

// Spec section 4, Step 5 — "described in consequences rather than
// settings." Defaults to 'open' (recommended) since that's the only tier
// that doesn't suppress recruiting.
export function PrivacyStep({ tier, onChangeTier }: { tier: PrivacyTier; onChangeTier: (tier: PrivacyTier) => void }) {
  return (
    <Stack spacing={2.5}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Who can see your site?
      </Typography>
      <Typography color="text.secondary">You can change this anytime, page by page, in Page Settings.</Typography>

      <Stack spacing={1.5}>
        {PRIVACY_TIERS.map((option) => {
          const selected = tier === option.id;
          return (
            <ButtonBase
              key={option.id}
              onClick={() => onChangeTier(option.id)}
              sx={{
                textAlign: 'left',
                borderRadius: 2,
                border: '2px solid',
                borderColor: selected ? 'primary.main' : 'divider',
                p: 2,
              }}
            >
              <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', width: '100%' }}>
                <Box sx={{ flex: 1 }}>
                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 0.5 }}>
                    <Typography sx={{ fontWeight: 700 }}>{option.name}</Typography>
                    {option.id === 'open' ? <Chip label="Recommended" size="small" color="primary" /> : null}
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {option.description}
                  </Typography>
                </Box>
                {selected ? <CheckCircleIcon size={22} weight="fill" color="var(--mui-palette-primary-main)" /> : null}
              </Stack>
            </ButtonBase>
          );
        })}
      </Stack>
    </Stack>
  );
}
